module.exports = new __parcel__URL__("microsoft_logo.a771f50c.png").toString();